import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Heart, BookOpen, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { aboutLinks, publicCtas, testimonyHighlights } from '@/content/public-site-content';

export default function TestimonyPage() {
  return (
    <div className="mx-auto w-full max-w-6xl space-y-8 p-6">
      <section className="rounded-[2rem] border border-border/70 bg-card/90 p-8 shadow-sm">
        <div className="space-y-4 text-center">
          <Badge variant="outline" className="mx-auto mb-2 w-fit">
            <Heart className="mr-1 h-3 w-3" />
            Testimony
          </Badge>
          <h1 className="text-4xl font-bold tracking-tight">God's Faithfulness in Our Story</h1>
          <p className="mx-auto max-w-2xl text-xl text-muted-foreground">
            The story of Dr. David Ogbueli's ministry is a testimony of obedience, growth, and God's unchanging faithfulness through every season.
          </p>
        </div>
      </section>

      <div className="grid gap-6 md:grid-cols-3">
        {testimonyHighlights.map((item) => (
          <Card key={item.title} className="border-border/70 bg-card/90 shadow-sm">
            <CardHeader>
              <CardTitle className="text-xl">{item.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm leading-6 text-muted-foreground">{item.body}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="bg-primary/5 border-primary/20">
        <CardContent className="p-8 text-center">
          <BookOpen className="h-12 w-12 text-primary mx-auto mb-4" />
          <h2 className="text-2xl font-bold mb-2">Explore More</h2>
          <p className="text-muted-foreground mb-6">
            Continue into the biography, vision, or the public broadcast.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {aboutLinks.filter(l => l.label !== 'Overview' && l.label !== 'Testimony').map((link) => (
              <Link key={link.href} to={link.href}>
                <Badge variant="outline" className="text-sm px-4 py-2 cursor-pointer hover:bg-primary/10">
                  {link.label}
                </Badge>
              </Link>
            ))}
            {publicCtas.slice(0, 3).map((cta) => (
              <Link key={cta.href} to={cta.href}>
                <Button variant={cta.href === '/media' ? 'default' : 'outline'}>
                  {cta.label}
                  {cta.href === '/media' && <ArrowRight className="ml-2 h-4 w-4" />}
                </Button>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
